// Loom embed prompt for the article editor (window.prompt is banned).
// Accepts share or embed URLs — getLoomEmbedUrl normalizes them.

import { useEffect, useState } from 'react'
import { isValidLoomUrl } from '@/components/help_center/editor/loomUrl'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/Dialog'

interface LoomDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (url: string) => void
}

export function LoomDialog({ open, onOpenChange, onSubmit }: LoomDialogProps) {
  const [url, setUrl] = useState('')

  useEffect(() => { if (open) setUrl('') }, [open])

  const valid = isValidLoomUrl(url.trim())

  const submit = () => {
    if (!valid) return
    onSubmit(url.trim())
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-left">
          <DialogTitle>Embed a Loom video</DialogTitle>
          <DialogDescription>Paste a Loom link (share or embed URL).</DialogDescription>
        </DialogHeader>
        <form onSubmit={e => { e.preventDefault(); submit() }} className="space-y-3">
          <div className="space-y-2">
            <Label htmlFor="loom-url">Loom URL</Label>
            <Input
              id="loom-url"
              autoFocus
              value={url}
              onChange={e => setUrl(e.target.value)}
              placeholder="https://www.loom.com/share/…"
            />
            {url.trim() !== '' && !valid && (
              <p className="text-xs text-destructive">That doesn't look like a Loom URL.</p>
            )}
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={!valid}>Embed</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
